/**
 * Politica de senha da casa — fonte unica para a API e para as telas.
 *
 * Mora aqui, e nao duplicada nos dois lados, porque regra de senha repetida
 * diverge: alguem afrouxa a tela e a API passa a recusar o que o formulario
 * aceitou, ou o contrario, e o usuario leva "senha invalida" sem entender.
 *
 * Nota tecnica: o bcrypt so considera os primeiros 72 bytes; com o teto de
 * 20 caracteres isso nunca e alcancado.
 */
export const SENHA_MIN = 8;
export const SENHA_MAX = 20;
export const REQUISITOS_SENHA = [
    {
        id: 'tamanho',
        texto: `De ${SENHA_MIN} a ${SENHA_MAX} caracteres`,
        atende: (s) => s.length >= SENHA_MIN && s.length <= SENHA_MAX,
    },
    {
        id: 'minuscula',
        texto: 'Uma letra minúscula',
        atende: (s) => /[a-z]/.test(s),
    },
    {
        id: 'maiuscula',
        texto: 'Uma letra maiúscula',
        atende: (s) => /[A-Z]/.test(s),
    },
    {
        id: 'numero',
        texto: 'Um número',
        atende: (s) => /[0-9]/.test(s),
    },
    {
        id: 'especial',
        // Qualquer coisa que nao seja letra nem numero conta — inclusive * & ? ~ |
        // e ate espaco. O texto diz "qualquer simbolo" e nao uma lista de exemplos
        // porque lista curta faz o usuario achar que os demais nao valem.
        texto: 'Um símbolo (qualquer um: * ! @ # etc.)',
        atende: (s) => /[^A-Za-z0-9]/.test(s),
    },
];
/** Requisitos que a senha NAO cumpre. Vazio = senha valida. */
export function requisitosFaltantes(senha) {
    return REQUISITOS_SENHA.filter((r) => !r.atende(senha));
}
export function senhaValida(senha) {
    return requisitosFaltantes(senha).length === 0;
}
/**
 * Mensagem de erro pronta, na forma "A senha precisa ter: X, Y e Z."
 * Usada pela API; a tela prefere a lista com marcadores, que mostra tambem
 * o que ja foi cumprido.
 */
export function mensagemSenhaInvalida(senha) {
    const faltam = requisitosFaltantes(senha);
    if (faltam.length === 0)
        return null;
    const itens = faltam.map((r) => r.texto.toLowerCase());
    const lista = itens.length === 1
        ? itens[0]
        : `${itens.slice(0, -1).join(', ')} e ${itens[itens.length - 1]}`;
    return `A senha precisa ter: ${lista}.`;
}
//# sourceMappingURL=password.js.map